module.exports = __webpack_public_path__ + "img/anxinkv.725529dc.png";